import React from 'react';
import EconomicCalendarDisclaimer from '../components/EconomicCalendarDisclaimer';
import { useTranslation } from 'react-i18next';
import { getUserHub } from 'modules/auth/selectors';
import { useSelector } from 'react-redux';
import { isCyHub } from 'modules/auth/helpers/hubs';

const EconomicCalendarDisclaimerContainer = () => {
  const { t } = useTranslation('economicCalendar');
  const hub = useSelector(getUserHub);

  return isCyHub(hub) ? <EconomicCalendarDisclaimer content={t('page.cySecDisclaimer')} /> : null;
};

export default EconomicCalendarDisclaimerContainer;
